import styled from 'styled-components';

import { Card } from 'components/ToolkitV2/CardV2/Card';

import { spacing } from 'helpers/genericStyles';

const VehicleDetailsCard = styled(Card)`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  ${spacing}
`;

export { VehicleDetailsCard };
